import React from "react";
import { Trans } from "react-i18next";
import "../../styles/components/Admin/ProfileDetails.scss";
import ErrorBoundaryHandler from "../ErrorBoundaryHandler";

interface ProfileDetailsType {
  patientDetails?: any;
}

const PatientProfileDetails = ({ patientDetails }: ProfileDetailsType) => {
  return (
    <div className="viewpatient">
      <div className="form-emergency-contact bg-light-gray text-capitalize">
        <h5 className="bg-light-blue p-2 heading">
          <Trans i18nKey={"emergency_contact_details"}></Trans>
        </h5>
        <div className="p-3 form-width">
          <span className="p-label">
            <label className="mt-0">
              <Trans i18nKey={"name"}></Trans>
            </label>
            <span>
              {patientDetails?.contact ? (
                patientDetails?.contact[0]?.name?.given[0]
              ) : (
                <Trans i18nKey={"unavailable"} />
              )}
            </span>
          </span>
          <span className="p-label">
            <label>
              <Trans i18nKey={"relationship"}></Trans>
            </label>
            <span>
              {patientDetails?.contact ? (
                <Trans
                  i18nKey={`list.${patientDetails?.contact[0]?.relationship[0]?.text}`}
                ></Trans>
              ) : (
                <Trans i18nKey={"unavailable"} />
              )}
            </span>
          </span>
          <span className="p-label">
            <label>
              <Trans i18nKey={"contact_number"}></Trans>
            </label>
            <span>
              {patientDetails?.contact ? (
                patientDetails?.contact[0]?.telecom[0]?.value
              ) : (
                <Trans i18nKey={"unavailable"} />
              )}
            </span>
          </span>
        </div>
      </div>
      <div className="form-address bg-light-gray mt-4">
        <h5 className="bg-light-blue p-2 heading">
          <Trans i18nKey={"address_details"}></Trans>
        </h5>
        <div className="p-3 form-width">
          <span className="p-label">
            <label className="mt-0">
              <Trans i18nKey={"street1"}></Trans>
            </label>
            <span>{patientDetails?.address[0]?.line[0]}</span>
          </span>
          {patientDetails?.address[0]?.line.length > 1 ? (
            <span className="p-label">
              <label>
                <Trans i18nKey={"street2"}></Trans>
              </label>
              <span>{patientDetails?.address[0]?.line[1]}</span>
            </span>
          ) : (
            ""
          )}
          <span className="p-label text-capitalize">
            <label>
              <Trans i18nKey={"city_village"}></Trans>
            </label>
            <span>{patientDetails?.address[0]?.city}</span>
          </span>
          <span className="p-label text-capitalize">
            <label>
              <Trans i18nKey={"district"}></Trans>
            </label>
            <span>{patientDetails?.address[0]?.district}</span>
          </span>
          <span className="p-label text-capitalize ">
            <label>
              <Trans i18nKey={"state"}></Trans>
            </label>
            <span>{patientDetails?.address[0]?.state}</span>
          </span>
          <span className="p-label">
            <label>
              <Trans i18nKey={"pincode"}></Trans>
            </label>
            <span>{patientDetails?.address[0]?.postalCode}</span>
          </span>
        </div>
      </div>
    </div>
  );
};

export default ErrorBoundaryHandler(PatientProfileDetails);
